import { lazyWithPreload } from '../../navigation';

export const CollectionScreen = lazyWithPreload(() =>
    import('./CollectionScreen').then((m) => ({ default: m.CollectionScreen }))
);
